import type { SkillTag } from "~/lib/api";

export const SKILL_CATEGORY_LABELS: Record<string, string> = {
  language: "Languages",
  platform: "Platforms",
  practice: "Practices",
  tool: "Tools",
  other: "Other",
};

export function skillsByCategory(tags: SkillTag[]): [string, SkillTag[]][] {
  const groups = new Map<string, SkillTag[]>();
  for (const tag of tags) {
    const list = groups.get(tag.category) ?? [];
    list.push(tag);
    groups.set(tag.category, list);
  }
  return [...groups.entries()];
}
